import {Box, Center, Flex, Icon, Text, Textarea} from '@chakra-ui/react'
import {Modal} from 'antd'
import {ReactComponent as StartIcon} from '@assets/svgs/start.svg'
import {ReactComponent as CheckCircleIcon} from '@assets/svgs/check_circle.svg'
import {useEffect, useState} from 'react'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {ReactComponent as ArrowRight} from '@assets/svgs/roadmap/arrow_right.svg'
import {useDispatch, useSelector} from 'react-redux'
import {
  getFeedbackOverview,
  updateIsShowModalPromoterScore,
} from '@redux/shared/shared'
import mapRequest from '@apis/map'
import appRequest from '@apis/app'
import {isLoggedIn} from '@utils'
import BackgroundDailyReview from '@assets/images/roadmap/background-daily-review.png'

const ModalPromoterScore = () => {
  const {isShowModalPromoterScore, dataFeedbackOverview} = useSelector(
    (state: any) => state.shared,
  )
  const [feedbackData, setFeedbackData] = useState<any>(null)
  const [isRated, setIsRated] = useState(false)
  const [step, setStep] = useState(1)
  const [isSent, setIsSent] = useState(false)
  const [data, setData] = useState<any>(null)
  const dispatch: any = useDispatch()

  useEffect(() => {
    if (dataFeedbackOverview) {
      getFeedbackData()
    }
  }, [dataFeedbackOverview])

  const getFeedbackData = async () => {
    try {
      const params = {
        'feedback-id':
          dataFeedbackOverview?.feedback_data?.FINISH_FIRST_SECTION
            ?.feedback_id,
      }
      const res = await mapRequest.getFeedbackData(params)
      if (res) {
        setFeedbackData(res?.data?.data)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleClickRate = (score: number) => {
    setIsRated(true)
    setData((prev: any) => ({...prev, score}))
    setStep(2)
  }

  const handleCancel = () => {
    dispatch(updateIsShowModalPromoterScore(false))
  }

  const handleClickReRate = () => {
    setIsRated(false)
    setData(null)
    setStep(1)
  }

  const handleOnchangeContent = (e: any) => {
    setData((prev: any) => ({...prev, content: e.target.value}))
  }

  const handleClickSubmit = () => {
    setIsSent(true)
    submitPromoteFeedback()
  }

  const handleClickClose = () => {
    dispatch(updateIsShowModalPromoterScore(false))
    dispatch(getFeedbackOverview())
  }

  const submitPromoteFeedback = async () => {
    try {
      let params
      if (isLoggedIn()) {
        params = {
          feedback_data_id:
            dataFeedbackOverview?.feedback_data?.FINISH_FIRST_SECTION
              ?.feedback_id,
          score: data?.score,
          explanation: data?.content || '',
        }
      } else {
        params = {
          feedback_data_id:
            dataFeedbackOverview?.feedback_data?.FINISH_FIRST_SECTION
              ?.feedback_id,
          feedback_data: {
            score: data?.score,
            explanation: data?.content || '',
          },
        }
      }
      const res = await appRequest.submitPromoteFeedback(params)
    } catch (error) {}
  }

  return (
    <Modal
      open={isShowModalPromoterScore}
      onCancel={handleCancel}
      title={
        <Center
          position={'relative'}
          w={'48px'}
          h={'48px'}
          border={'1px solid #EAECF0'}
          borderRadius={'50%'}
          bg={isSent ? '#DCFAE6' : 'unset'}>
          <Icon w={'24px'} h={'24px'}>
            {isSent ? <CheckCircleIcon /> : <StartIcon />}
          </Icon>
          <Box
            position={'absolute'}
            top={'50% '}
            left={'50%'}
            transform={'translate(-50%, -50%)'}
            w={'300px'}
            h={'300px'}
            bgImage={BackgroundDailyReview}
            bgSize={'cover'}
            bgPosition={'center'}
          />
        </Center>
      }
      width={isSent ? '400px' : '520px'}
      centered={true}
      footer={null}
      closeIcon={isSent ? null : undefined}
      style={{
        overflow: 'hidden',
      }}>
      {isSent ? (
        <Box>
          <Text fontSize={'18px'} fontWeight={600}>
            Cảm ơn bạn nhiều
          </Text>
          <Text>Hẹn gặp bạn trong bài học tiếp theo nha!</Text>
          <GlobalButton mt={'40px'} w={'100%'} onClick={handleClickClose}>
            Học tiếp{' '}
            <Icon
              as={ArrowRight}
              ml={2}
              w={'20px'}
              h={'20px'}
              sx={{
                path: {
                  stroke: 'white',
                },
              }}
            />
          </GlobalButton>
        </Box>
      ) : (
        <Box>
          <Text fontSize={'18px'} fontWeight={600}>
            {feedbackData?.feedback_data?.data[step - 1]?.text}
          </Text>
          {
            <Text>
              {feedbackData?.feedback_data?.data[step - 1]?.sub_text || ''}
            </Text>
          }
          {isRated ? (
            <Box mt={'24px'}>
              <Textarea
                placeholder="Nhập nội dung"
                resize={'none'}
                onChange={handleOnchangeContent}
              />
              <Flex mt={'24px'} gap={'12px'}>
                <GlobalButton
                  flex={1}
                  color={'black'}
                  bg={'transparent'}
                  border={'1px solid #D0D5DD'}
                  _hover={{
                    bg: 'transparent',
                  }}
                  onClick={handleClickReRate}>
                  Chọn lại
                </GlobalButton>
                <GlobalButton flex={1} onClick={handleClickSubmit}>
                  Gửi
                </GlobalButton>
              </Flex>
            </Box>
          ) : (
            <Box mt={'24px'} pb={'24px'}>
              <Flex gap={'10px'}>
                {Array.from({
                  length: Number(
                    feedbackData?.feedback_data?.data[step - 1]?.total_score,
                  ),
                }).map((_, index) => (
                  <Center
                    key={index}
                    cursor={'pointer'}
                    flex={1}
                    aspectRatio={'1/1'}
                    border={'1px solid #D0D5DD'}
                    borderRadius={'8px'}
                    _hover={{
                      bg: '#D6EBFF',
                      border: '1px solid #70BAFF',
                      color: '#0069CC',
                    }}
                    onClick={() => handleClickRate(index + 1)}>
                    <Text fontSize={'18px'} fontWeight={600}>
                      {index + 1}
                    </Text>
                  </Center>
                ))}
              </Flex>
              <Flex justifyContent={'space-between'} mt={'16px'}>
                <Text>{feedbackData?.feedback_data?.data[step - 1]?.min}</Text>
                <Text>{feedbackData?.feedback_data?.data[step - 1]?.max}</Text>
              </Flex>
            </Box>
          )}
        </Box>
      )}
    </Modal>
  )
}

export default ModalPromoterScore
